import { Stack, Typography } from "@mui/material";

export const EmptyNotificationList = () => {
  return (
    <Stack justifyContent="center" alignItems="center" height="100%">
      <Typography variant="h6">お知らせはありません</Typography>
    </Stack>
  );
};
